import AdCard from './AdCard';

export default AdCard;
